import i18n from "@/i18n";
import configs from "@/i18n/configs";
import { cancelAdministrativeDayLeave } from '@/configs/global.config'
import store from '../store'

export const userType = {
    supervisor: 0,
    medicalRep: 1,
    admin: 2,
}
export const userTypes = [
    { id: 0, name: i18n.t('userTypes.administrative') },
    { id: 1, name: i18n.t('userTypes.medical-rep') },
]

export const gender = {
    male: 0,
    female: 1
};
export const genders = [
    { id: 0, name: i18n.t('inputs.male') },
    { id: 1, name: i18n.t('inputs.female') }
];

export const workloads = [
    { id: 0, name: 'A+' },
    { id: 1, name: 'A' },
    { id: 2, name: 'A-' },
    { id: 3, name: 'B+' },
    { id: 4, name: 'B' },
    { id: 5, name: 'B-' },
    { id: 6, name: 'C' },
];

export const contactInfoTypes = [
    { id: 0, name: 'Phone' },
    { id: 1, name: 'Landline' },
    { id: 2, name: 'Email' },
    { id: 3, name: 'Facebook' },
    { id: 4, name: 'Twitter' },
    { id: 5, name: 'WhatsApp' },
    { id: 6, name: 'Telegram' },
    { id: 7, name: 'LinkedIn' },
    { id: 8, name: 'Website' },
];
export const contactInfoType = {
    phone: 0,
    landline: 1,
    email: 2,
    facebook: 3,
    twitter: 4,
    whatsapp: 5,
    telegram: 6,
    linkedin: 7,
    website: 8,
};

export const entityType = {
    center: 0,
    doctor: 1,
    pharmacy: 2,
    external: 3,
}

export const entityTypeArray = [
    {
        id:0,
        name: i18n.t('tabs.center')
    },
    {
        id: 1,
        name: i18n.t('tabs.doctor')
    },
    {
        id: 2,
        name: i18n.t('tabs.pharmacy')
    },
    {
        id: 3,
        name: i18n.t('tabs.external')
    }
];

export const requestTypes = [
    !cancelAdministrativeDayLeave ? { id: 0, name: i18n.t('leaves.administrative-day') } : null,
    { id: 4, name: i18n.t('leaves.administrative-leave') },
    !cancelAdministrativeDayLeave ? { id: 1, name: i18n.t('leaves.half-administrative-day') } : null,
    { id: 2, name: i18n.t('leaves.sick-leave') },
    { id: 3, name: i18n.t('leaves.unpaid-leave') },
]

export const requestStates = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Accepted' },
    { id: 2, name: 'Rejected' },
]

export const requestStatus = {
    pending: 0,
    accepted: 1,
    rejected: 2,
}

export const modificationRequestTypes = {
    creation: 0,
    modification: 1,
    deletion: 2,
}

export const permissions = { 
    Leaves: 0,
    AddLeavesForStaff: 1,
    ManageLeaveBalances: 2,
    GenerateMaterials: 3,
    MaterialTransactions: 4,
    MedicalPlans: 5,
    MedicalVisits: 6,
    WeeklyReports: 7,
    MonthlyPlanReports: 8,
    Reviews: 9,
    Exams: 10,
    Salaries: 11,
    MedicalReps: 12,
    Entities: 13,
    EntityModificationRequests: 14,
    Charts: 15,
    Regions: 16,
    Users: 17,
    Roles: 18,
    GeneralFilter: 19,
    ManageTeam: 20
}

export const permissionsWithName = [
    {
       permissionName: 'Leaves',
       id: 0 
    },
    {
        permissionName: 'Add Leaves For Staff',
        id: 1
    },
    {
        permissionName: 'Manage Leave Balances',
        id: 2
    },
    {
        permissionName: 'Generate Materials',
        id: 3
    },
    {
        permissionName: 'Material Transactions',
        id: 4
    },
    {
        permissionName: `${configs.medicalRepPlan.en}`,
        id: 5
    },
    {
        permissionName: `${configs.medicalVisits.en}`,
        id: 6
    },
    {
        permissionName: 'Weekly Reports',
        id: 7
    },
    {
        permissionName: 'Monthly Plan Reports',
        id: 8
    },
    {
        permissionName: 'Reviews',
        id: 9
    },
    {
        permissionName: 'Exams',
        id: 10
    },
    {
        permissionName: 'Salaries',
        id: 11
    },
    {
        permissionName: `${configs.MedicalReps.en}`,
        id: 12
    },
    {
        permissionName: 'Entities',
        id: 13
    },
    {
        permissionName: 'Entity Modification Requests',
        id: 14
    },
    {
        permissionName: 'Charts',
        id: 15
    },
    {
        permissionName: 'Regions',
        id: 16
    },
    {
        permissionName: 'Users',
        id: 17
    },
    {
        permissionName: 'Roles',
        id: 18
    },
    {
        permissionName: 'GeneralFilter',
        id: 19
    },
    {
        permissionName: 'ManageTeam',
        id: 20
    }
]
export const roleName = {
    nothing: 0,
    read : 1,
    action: 2
}

export const transactionState = [
    { name: i18n.t('JournalItems.ravages'), id: 1 },  
    { name: i18n.t('JournalItems.stocktaking'), id: 2 }
]

export const typeEmployees = [
    {
        name: 'Administrative',
        id: 0
    },
    {
        name: 'Medical rep',
        id: 1
    }
]

export const classificationReport = [
    {
        id: 0,
        name: 'Important' 
    },
    {
        id: 1,
        name: 'Complaint' 
    },
    {
        id: 2,
        name: 'Normal note' 
    }
]

export const loyalty = [
    {
        id: 0,
        name: 'High'
    },
    {
        id: 1,
        name: 'Moderate'
    },
    {
        id: 2,
        name: 'Low'
    }
]

export const religion = [
    {
        id: 0,
        name: 'Muslim'
    },
    {
        id: 1,
        name: 'Christian'
    },
    {
        id: 2,
        name: 'Armenian'
    },
    {
        id: 3,
        name: 'Other'
    }
]

export const personality = [
    {
        id: 0,
        name: 'C' 
    },
    {
        id: 1,
        name: 'D' 
    },
    {
        id: 2,
        name: 'I'
    },
    {
        id: 3,
        name: 'S'
    },
    {
        id: 4,
        name: 'Other'
    }
]

export const accountType = [
    { accountId: 1, name: i18n.t('SamplesStatement.customers'), },
    { accountId: 2, name: i18n.t('SamplesStatement.external-entities'), },
    { accountId: 0, name: i18n.t('SamplesStatement.staff'), }
]

export const accountTypeValue = {
    staff: 0,
    customer: 1,
    'external-entities': 2
}

export const paymentMethods = [
    {
        id: 1,
        name: i18n.t('payment.cash')
    },
    {
        id: 2,
        name: i18n.t('payment.credit')
    },
    {
        id: 3,
        name: i18n.t('payment.debt')
    }
]

export const fieldsInStaff = {
    phoneNumber: 1,
    address: 2,
    jobPosition: 3,
    startingDate: 4,
    lineManagerId: 5,
    roleId: 6,
    regionIds: 7,
    specialtyIds: 8,
    teamId: 9,
    username: 10,
    password: 11,
    employeeType: 12,
    sectorId: 13,
    name: 14
}
// sam sam permissions
export const fieldsInStaffRole = {
    landlineNumber: 1,
    email: 2,
    facebookProfileUrl: 3,
    gender: 4,    
    leaveDaysNumber: 5,
    certificate: 6,
    targetValue: 7,
    financialTargetValue: 8,
    birthDate: 9,
}

export const fieldsInCustomers = {
    name: 1,
    type: 2,
    // entityType: 3,
    bestTimeToVisit: 3,
    openingTime: 4,
    closingTime: 5,
    contactInfo: 6,
    // addresses
    address: 7,
    loyalty: 8,
    weekend: 9,
    workHoursFrom: 10,
    workHoursTo: 11,
    visitNotes: 12
}

export const fieldsInCustomersType = {
    // specialtyId
    specialty: 1,
    residentDoctorNames: 2,
    religion: 3,
    personality: 4,
    birthdate: 5,
    personalNote: 6,
    doctorHobbies: 7,
    nearByPharmacies: 8,
    worksInCenters: 9,
    pharmacistInfo: 10,
    pharmacyInfo: 11,
    classification: 12
}

export const fieldsInMaterials = {
    number: 1,
    name: 2,
    materialFormId: 3,
    description: 4,
    dose: 5,
    strength: 6,
    pillsPerBox: 7,
    price: 8,
    leafletFilePath: 9,
    specialty: 10,
    minAmount: 11,
    maxAmount: 12,
    compositionPerUnit: 13,
    pharmaciesPrice: 14,
    priceTypes: 15,
    priceDiscountRate: 16
}

export const fieldsVisits = {
    entityId: 1,
    freeSample: 2,
    otherSamples: 3,
    notes: 4, 
    objections: 5,
    nextVisitNotes: 6,
    purpose: 7,
    materialAmounts: 8,
    unavailableMaterialIds: 9,
    competitiveSamples: 10,
    coreMessage: 11,
    longitude: 12, 
    latitude: 13,
    durationInMinutes: 14,
    amountReceived: 15,
    residentDoctorNames: 16,
    payment: 17, 
    priceTypeId: 18,
    specialtyId: 19
}
export const sectionType = {
    staff: 1,
    customers: 2,
    materials: 3,
    visits: 4,
    customerTypeOne: store.state.configuration.customersTypesConf.length
}
// requestStockKey